var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Card.tsx
import { default as MuiCard } from "@mui/material/Card";
import { jsx } from "react/jsx-runtime";
var Card = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx(MuiCard, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/CardActionArea.tsx
import {
  default as MuiCardActionArea
} from "@mui/material/CardActionArea";
import { jsx as jsx2 } from "react/jsx-runtime";
var CardActionArea = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx2(MuiCardActionArea, __spreadProps(__spreadValues({}, rest), { disableRipple: true, children }));
};

// src/lib/CardActions.tsx
import { default as MuiCardActions } from "@mui/material/CardActions";
import { jsx as jsx3 } from "react/jsx-runtime";
var CardActions = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx3(MuiCardActions, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/CardContent.tsx
import { default as MuiCardContent } from "@mui/material/CardContent";
import { jsx as jsx4 } from "react/jsx-runtime";
var CardContent = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx4(MuiCardContent, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/CardHeader.tsx
import { default as MuiCardHeader } from "@mui/material/CardHeader";

// ../chip/src/lib/Chip.tsx
import { default as MuiChip } from "@mui/material/Chip";
import { jsx as jsx5 } from "react/jsx-runtime";

// ../chip/src/lib/StatusChip.tsx
import { default as MuiChip2 } from "@mui/material/Chip";
import { jsx as jsx6 } from "react/jsx-runtime";
var StatusChip = (_a) => {
  var _b = _a, { color = "default" } = _b, rest = __objRest(_b, ["color"]);
  return /* @__PURE__ */ jsx6(MuiChip2, __spreadProps(__spreadValues({ color }, rest), { size: "small" }));
};

// src/lib/CardHeader.tsx
import { Fragment, jsx as jsx7, jsxs } from "react/jsx-runtime";
var CardHeader = (_a) => {
  var _b = _a, {
    titleTypographyProps,
    subheaderTypographyProps,
    statusChipProps,
    action,
    subheader,
    title,
    logo
  } = _b, rest = __objRest(_b, [
    "titleTypographyProps",
    "subheaderTypographyProps",
    "statusChipProps",
    "action",
    "subheader",
    "title",
    "logo"
  ]);
  return /* @__PURE__ */ jsx7(
    MuiCardHeader,
    __spreadProps(__spreadValues({}, rest), {
      title: logo ? /* @__PURE__ */ jsxs(Fragment, { children: [
        logo,
        /* @__PURE__ */ jsx7("br", {}),
        title
      ] }) : title,
      titleTypographyProps: __spreadProps(__spreadValues({}, titleTypographyProps), {
        variant: "h5"
      }),
      subheaderTypographyProps: __spreadProps(__spreadValues({}, subheaderTypographyProps), { variant: "body2" }),
      subheader: statusChipProps && statusChipProps.position === "bottom" ? /* @__PURE__ */ jsxs(Fragment, { children: [
        subheader,
        /* @__PURE__ */ jsx7("br", {}),
        /* @__PURE__ */ jsx7(StatusChip, __spreadValues({}, statusChipProps))
      ] }) : subheader,
      action: statusChipProps && statusChipProps.position === "right" ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx7(StatusChip, __spreadValues({}, statusChipProps)),
        action
      ] }) : action
    })
  );
};

// src/lib/CardMedia.tsx
import { default as MuiCardMedia } from "@mui/material/CardMedia";
import { jsx as jsx8 } from "react/jsx-runtime";
var CardMedia = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx8(MuiCardMedia, __spreadProps(__spreadValues({}, rest), { children }));
};
export {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia
};
